import classNames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';

import styles from './network-loader.scss';

interface Props {
  activeRequests: number;
}

const NetworkLoader = ({ activeRequests }: Props) => {
  return (
    <div
      className={classNames(styles.progress, {
        [styles.loading]: activeRequests > 0,
      })}
    >
      <div className={styles.progressInner} />
    </div>
  );
};

export default connect((state: any) => ({
  activeRequests: state.requestsCounter,
}))(NetworkLoader);
